import URL from "@/constants/baseurl";

export default {
    namespaced: true,
    state: () => ({
        locations: [],

        location_filters: {
            location_name: '',
            branch_id: '',
            status: '1',
            page: 1,
        }

    }),
    mutations: {
        SET_LOCATIONS(state, locations) {
            state.locations = locations;
        }

    },
    actions: {

        set_locations({ commit }, data) {
            commit('SET_LOCATIONS', data);
        },

        async get_locations({ state, commit }) {
            const apiToken = localStorage.getItem('token');
            const url = `${URL.BASEURL}/api/get-locations`;

            let filters = {
                location_name: state.location_filters.location_name,
                branch_id: state.location_filters.branch_id,
                status: state.location_filters.status,
                page: state.location_filters.page,
            };

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify(filters)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const res = await response.json();
                commit('SET_LOCATIONS', res);
            } catch (error) {
                console.error('Error fetching locations:', error);
            }
        }

    },
    getters: {}
}
